var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconJob(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.33667C12.0937 10.1075 10.0563 10.5025 8 10.5C5.878 10.5 3.85333 10.0867 2 9.33667M10.6667 4.5V3.16667C10.6667 2.81305 10.5262 2.47391 10.2761 2.22386C10.0261 1.97381 9.68696 1.83333 9.33333 1.83333H6.66667C6.31304 1.83333 5.97391 1.97381 5.72386 2.22386C5.47381 2.47391 5.33333 2.81305 5.33333 3.16667V4.5M8 8.5H8.00667M3.33333 13.8333H12.6667C13.0203 13.8333 13.3594 13.6929 13.6095 13.4428C13.8595 13.1928 14 12.8536 14 12.5V5.83333C14 5.47971 13.8595 5.14057 13.6095 4.89052C13.3594 4.64048 13.0203 4.5 12.6667 4.5H3.33333C2.97971 4.5 2.64057 4.64048 2.39052 4.89052C2.14048 5.14057 2 5.47971 2 5.83333V12.5C2 12.8536 2.14048 13.1928 2.39052 13.4428C2.64057 13.6929 2.97971 13.8333 3.33333 13.8333Z",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconJob);
export default __webpack_public_path__ + "static/media/common_icon_job.ade9a3f2a7ca4154036f3ea9d19f2518.svg";
export { ForwardRef as ReactComponent };